import { useCurrentUser } from "@/features/auth/useCurrentUser";
import { Anchor } from "../ui/anchor";
import { ROLE } from "@/utils/constant";

export function editAnchor(param?: { href?: string }) {
  return function (
    _ButtonWithModal: React.JSX.Element,
    _ButtonWithAction: React.JSX.Element,
    row: { [key: string]: unknown },
  ) {
    const { href } = param ?? {};
    const { roles } = useCurrentUser();
    const isVendor = roles?.includes(ROLE.VENDOR);

    return (
      <>
        {isVendor ? null : (
          <Anchor mood="axiata-blue-link" href={href ?? `./${row.id}/edit`}>
            Edit
          </Anchor>
        )}
      </>
    );
  };
}
